import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Tabs, Icon } from 'antd';
import EventCards from '../layoutComponents/EventCards'
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import FollowList from '../layoutComponents/followList/FollowList';

@observer(["web3Store", "eventStore", "ViewStore", "CategoriesStore", "TeamStore", "AdminStore", "UserStore", "AuthStore"])
class Watchlist extends Component {
    constructor(props) {
        super(props);

        this.state = {
            teamsEventList: [],
            loading: true,
            currentTab: 1,
        };
        this.renderAllOpenEvents = this.renderAllOpenEvents.bind(this);
        this.renderTeamOpenEvents = this.renderTeamOpenEvents.bind(this);
        this.renderLeagueOpenEvents = this.renderLeagueOpenEvents.bind(this);
        this.renderCategoryOpenEvents = this.renderCategoryOpenEvents.bind(this);
        this.handleClickTab = this.handleClickTab.bind(this);
    }

    async componentWillMount() {
        this.props.ViewStore.changeView('Watchlist');
        this.props.ViewStore.changeCurrentPage('Watchlist')
        const { TeamStore } = this.props;
        let self = this;
        let teamList = [];
        TeamStore.queryTeams().then(async () => {
            setTimeout(() => {
                self.setState({ teams: Array.from(TeamStore.teams.values()) });
            }, 500)

        });
    }
    async componentDidMount() {
        let self = this;
        if (this.props.AuthStore.userAuth.auth !== undefined) {
            let authToken = this.props.AuthStore.userAuth.auth.accessToken;

            self.props.UserStore.updateUserBets(authToken);
        }
        setTimeout(() => {
            self.setState({ loading: false })
        }, 200);
    }

    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('Watchlist')
    }

    handleClick() {
        this.props.ViewStore.changeGridList()
    }

    renderEvent(event) {
        let time = new Date().getTime() / 1000;
        let startTime = new Date();
        startTime.setTime(event.startTime * 1000);
        let startTimeString = startTime.toLocaleTimeString() + " - " + startTime.toLocaleDateString();

        return (
            <EventCards
                key={event._id}
                event={event} />
        );
    }

    renderAllOpenEvents() {
        const { UserStore, AdminStore } = this.props;
        let timeNow = new Date().getTime() / 1000;
        console.log('Time now:' + timeNow);
        let eventList = [];
        for (let event of UserStore.allFollowedEvents.values()) {
            if (event.startTime + event.duration > timeNow) {
                if (!event.cancelled && !event.finalized) {
                    eventList.push(this.renderEvent(event));
                }
            }
        }
        return (eventList.length > 0 ? eventList : <h3>No events found</h3>);
    }

    renderTeamOpenEvents() {
        const { UserStore, AdminStore } = this.props;
        let timeNow = new Date().getTime() / 1000;
        console.log('Time now:' + timeNow);
        let eventList = [];
        for (let event of UserStore.teamsFollowedEvents.values()) {
            if (event.startTime + event.duration > timeNow) {
                if (!event.cancelled && !event.finalized) {
                    eventList.push(this.renderEvent(event));
                }
            }
        }
        return (eventList.length > 0 ? eventList : <h3>No events found</h3>);
    }

    renderLeagueOpenEvents() {
        const { UserStore, AdminStore } = this.props;
        let timeNow = new Date().getTime() / 1000;
        console.log('Time now:' + timeNow);
        let eventList = [];
        for (let event of UserStore.leaguesFollowedEvents.values()) {
            if (event.startTime + event.duration > timeNow) {
                if (!event.cancelled && !event.finalized) {
                    eventList.push(this.renderEvent(event));
                }
            }
        }
        return (eventList.length > 0 ? eventList : <h3>No events found</h3>);
    }

    renderCategoryOpenEvents() {
        const { UserStore, AdminStore } = this.props;
        let timeNow = new Date().getTime() / 1000;
        console.log('Time now:' + timeNow);
        let eventList = [];
        for (let event of UserStore.categoriesFollowedEvents.values()) {
            if (event.startTime + event.duration > timeNow) {
                if (!event.cancelled && !event.finalized) {
                    eventList.push(this.renderEvent(event));
                }
            }
        }
        return (eventList.length > 0 ? eventList : <h3>No events found</h3>);
    }

    handleClickTab(key) {
        this.setState({currentTab: key});
    }

    render() {
        const TabPane = Tabs.TabPane;
        const activeTab = Tabs.TabPane.activeKey
        let gridColumnEvents = "";
        let gridListIcon = "";

        if (this.props.ViewStore.getHeaderState === true) {
            gridColumnEvents = '100%';

        } else {
            if (this.props.ViewStore.getGridList === "list") {
                gridListIcon = <Icon type="appstore" onClick={this.handleClick} />
                gridColumnEvents = '100%';
            } else {
                gridListIcon = <Icon type="bars" onClick={this.handleClick} />
                gridColumnEvents = '49.2% 49.2%';
            }
        }

        return (
            <div className="watchlist">
                <Tabs defaultActiveKey="1">
                    <TabPane tab="All" key="1" onClick={() => this.handleClickTab(1)}>
                        <div className="main-page-cards" style={{ gridTemplateColumns: gridColumnEvents }}>
                            {!this.state.loading ? this.renderAllOpenEvents() : <Icon type="loading" />}
                        </div>
                    </TabPane>
                    <TabPane tab="Teams" key="2" onClick={() => this.handleClickTab(2)}>
                        <div className="main-page-cards" style={{ gridTemplateColumns: gridColumnEvents }}>
                            {!this.state.loading ? this.renderTeamOpenEvents() : <Icon type="loading" />}
                        </div>
                    </TabPane>
                    <TabPane tab="Leagues" key="3" onClick={() => this.handleClickTab(3)}>
                        <div className="main-page-cards" style={{ gridTemplateColumns: gridColumnEvents }}>
                            {!this.state.loading ? this.renderLeagueOpenEvents() : <Icon type="loading" />}
                        </div>
                    </TabPane>
                    <TabPane tab="Sports" key="4" onClick={() => this.handleClickTab(4)}>
                        <div className="main-page-cards" style={{ gridTemplateColumns: gridColumnEvents }}>
                            {!this.state.loading ? this.renderCategoryOpenEvents() : <Icon type="loading" />}
                        </div>
                    </TabPane>
                   
                </Tabs>
                <FollowList currentTab={this.state.currentTab}/>
            </div>
        );
    }
}

export default inject('store')(observer(Watchlist));


// WEBPACK FOOTER //
// ./src/components/appComponents/Watchlist.js